// @flow strict

export const CANCEL_ICON_TYPE: 'cancel' = 'cancel';
export const EDIT_ICON_TYPE: 'edit' = 'edit';
export const SAVE_ICON_TYPE: 'save' = 'save';

export const FILE_ICON_COLUMN_INDEX = 0;
export const FILE_ICON_COLUMN_WIDTH = 54;
export const FILE_ICON_SIZE = 32;
export const FILE_NAME_COLUMN_INDEX = 1;
export const FILE_NAME_COLUMN_WIDTH = 350;
export const FIXED_COLUMNS_NUMBER = 2; // 2 Sticky columns - 1. file-icon, 2. file-name for each row
export const FIXED_ROW_NUMBER = 1; // Header row
export const HEADER_ROW_INDEX = 0;
export const MIN_METADATA_COLUMN_WIDTH = 250;
